import { render, staticRenderFns } from "./VideoBackgroundEditor.vue?vue&type=template&id=46481b48&scoped=true"
import script from "./VideoBackgroundEditor.vue?vue&type=script&lang=js"
export * from "./VideoBackgroundEditor.vue?vue&type=script&lang=js"
import style0 from "./VideoBackgroundEditor.vue?vue&type=style&index=0&id=46481b48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46481b48",
  null
  
)

export default component.exports